// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Rational_Extra from "../Data.Rational.Extra/index.js";
import * as Data_Show from "../Data.Show/index.js";
var toString = function (dict) {
    return dict.toString;
};
var parse = function (dict) {
    return dict.parse;
};
var editAsStringString = {
    toString: Control_Category.identity(Control_Category.categoryFn),
    parse: Data_Maybe.Just.create
};
var editAsStringSerializedRational = {
    toString: Data_Rational_Extra.toString(Data_Rational_Extra.asRationalSerialized),
    parse: Data_Rational_Extra.fromString(Data_Rational_Extra.asRationalSerialized)
};
var editAsStringNumber = {
    toString: Data_Show.show(Data_Show.showNumber),
    parse: Data_Number.fromString
};
var editAsStringMoney = {
    toString: Data_Money_Rounded.toString,
    parse: Data_Money_Rounded.fromString
};
var editAsStringMaybe = function (dictEditAsString) {
    return {
        toString: Data_Maybe.maybe("")(toString(dictEditAsString)),
        parse: function (v) {
            if (v === "") {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Maybe.Nothing.value);
            };
            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Maybe.Just.create)(parse(dictEditAsString)(v));
        }
    };
};
var editAsStringInt = {
    toString: Data_Show.show(Data_Show.showInt),
    parse: Data_Int.fromString
};
export {
    parse,
    toString,
    editAsStringString,
    editAsStringInt,
    editAsStringNumber,
    editAsStringMoney,
    editAsStringMaybe,
    editAsStringSerializedRational
};
//# sourceMappingURL=index.js.map
